<template>
  <div class="detailPage" v-loading="loading">
    <header class="detaiHead">
      <span class="back" @click="backRoute_"><i class="dnnfont iconangleleft" style="position:relative;margin-right:8px;"></i>返回</span>
      <span class="name">{{ getName }}</span>
      <span class="type">
        <slot name="type"></slot>
      </span>
      <span class="rightQuery">
        <slot name="right"></slot>
      </span>
    </header>
    <main class="detailMain">
      <slot name="detailMain"></slot>
    </main>
  </div>
</template>

<script>
export default {
  props: {
    backRoute: {
      //路由
      type: String,
      default: '',
    },
    name: {
      //名称
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    param: {
      type: Object, //携带参数
      default: function () {
        return {}
      },
    },
  },
  computed: {
    getName() {
      return this.name == '' ? this.$route.name : this.name
    },
  },
  methods: {
    backRoute_() {
      if (this.backRoute == '') {
        this.$router.go(-1)
      } else {
        if (this.param != {}) {
          this.$router.push({
            path: this.backRoute,
            query: this.param,
          })
        } else {
          this.$router.push(this.backRoute)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.detailPage {
  width: 100%;
  height: 100%;
  padding-bottom: 0;
  background-color: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .detaiHead {
    padding: 0px 20px;
    width: 100%;
    height: 64px;
    line-height: 64px;
    border-bottom: 1px solid #ebebeb;
    box-sizing: border-box;
    .back {
      font-size: 14px;
      cursor: pointer;
      color: #666666;
      padding-right: 32px;
      border-right: 1px solid #ebebeb;
      height: 28px;
      line-height: 28px;
      display: inline-block;
      .dnnfont {
        position: relative;
        top: 2px;
      }
    }
    .name {
      margin-left: 28px;
      color: #666666;
      font-size: 14px;
    }
    .back,
    .name {
      &:hover {
        color: #f66b3d;
      }
    }

    .type {
      margin-left: 12px;
    }
    .rightQuery {
      height: 28px;
      line-height: 28px;
      float: right;
      margin-top: 18px;
    }
  }
  .detailMain {
    height: calc(100% - 65px);
    padding: 20px;
    overflow: auto;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// DetailPage.vue?393213bc